var _defs, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M23.709 25.358l-3.213 2.335c-1.06.77-2.487-.266-2.082-1.513l1.227-3.778-3.213-2.335c-1.06-.77-.515-2.448.795-2.448h3.972l1.227-3.778c.405-1.247 2.169-1.247 2.574 0l1.227 3.778h3.972c1.311 0 1.856 1.677.795 2.448l-3.213 2.335 1.227 3.778c.405 1.247-1.022 2.283-2.082 1.513l-3.213-2.335z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 36.279,
    cy: 28.667,
    r: 1.445
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.181 8.786a3.84 3.84 0 10-7.68 0v3.215h7.638l.042-3.215zM11.138 12.001v25.634h25.141v-4.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.615 4.945h24.824a3.84 3.84 0 013.84 3.84v14.904"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageBonus);
export default __webpack_public_path__ + "static/media/PercentageBonus.7110fb4bafbeae8875870ef3f46d2fbf.svg";
export { ForwardRef as ReactComponent };